<!-- filter -->
<app-filter></app-filter>

<!-- main -->
<div class="container-fluid">
    <div class="row">
        <div class="col">
            <div class="container-tab">
                <div class="tabs">
                    <a *ngFor="let tab of TABS" [routerLink]="['/' + tab.path]" [ngClass]="{ 'active': path === tab.path }"
                        (click)="path = tab.path">{{tab.name}}</a>
                </div>
                <div class="panel">
                    <router-outlet></router-outlet>
                </div>
            </div>
        </div>
    </div>
</div>